import { githubCheck } from './lib/github-check';
import { defaultAntennaData } from './constants/defaultAntennaData';
import { defaultRxData } from './constants/defaultRxData';
import { defaultTxData } from './constants/defaultTxData';
import { defaultSignalData } from './constants/defaultSignalData';
import { defaultUserData } from './constants/defaultUserData';

export const antennas = [
  { band: 'C', upconvert: 3350e6, downconvert: 3500e6 },
  { band: 'Ku', upconvert: 14400e6, downconvert: 14250e6 },
];

export const satellites = [
  { id: 1, name: 'ARKE 3G', offset: 400e6 },
  { id: 2, name: 'AURORA 2B', offset: 450e6 },
  { id: 3, name: 'AUXO STAR', offset: 420e6 },
  { id: 4, name: 'ENYO', offset: 300e6 },
  { id: 5, name: 'HASHCOMM 7', offset: 365e6 },
  { id: 6, name: 'HUF UHF FO', offset: 210e6 },
  { id: 7, name: 'MERCURY PAWN', offset: 150e6 },
  { id: 8, name: 'NYXSAT', offset: 250e6 },
  { id: 9, name: 'RASCAL', offset: 120e6 },
  { id: 10, name: 'WILL 1-AM', offset: 345e6 },
];

export const teams = githubCheck()
  ? [{ id: 1, name: 'Lone Player' }]
  : [
      { id: 1, name: 'Persephone' },
      { id: 2, name: 'Sisyphus' },
      { id: 3, name: 'Tartarus' },
      { id: 4, name: 'Zagreus' },
    ];

export { defaultAntennaData, defaultRxData, defaultTxData, defaultSignalData, defaultUserData };
